import { render, staticRenderFns } from "./paciente-edit.vue?vue&type=template&id=2a03961a&"
import script from "./paciente-edit.vue?vue&type=script&lang=js&"
export * from "./paciente-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports